import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../data/services';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
export function Services() {
  return <section id="services" className="bg-cream py-24 sm:py-32" data-id="element-292" data-mp="1dshjqs1y21a9">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-293" data-mp="18vr05uqxknk3">
        <Reveal data-id="element-294" data-mp="18xagflcl6ylv">
          <div className="max-w-3xl" data-id="element-295" data-mp="13vl7cb8xcv0f">
            <Eyebrow data-id="element-296" data-mp="13wmsj8jnmxvv">What We Do</Eyebrow>
            <h2 className="mt-6 font-display text-[clamp(2.1rem,5vw,3.8rem)] leading-[1.02] tracking-[-0.02em] text-navy-900" data-id="element-297" data-mp="13xpm5o8d3efh">
              From Fresh Paint to
              <span className="block italic text-brass-dark" data-id="element-298" data-mp="u6l4uhv7rhhh">Full Transformations.</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ink-700/70" data-id="element-299" data-mp="q6199iqaglxg">
              Whether it&rsquo;s a single room refresh or a whole-home renovation, every
              project gets the same preparation, craftsmanship, and finish.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-300" data-mp="36awq2k20032c">
          {services.map((service, i) => <Reveal key={service.id} delay={i % 3 * 0.08} data-id="element-301" data-mp="3b5an0qwb6i94" data-mpi={i}>
              <motion.a href="#contact" whileHover={{
            y: -6
          }} transition={{
            duration: 0.35,
            ease: [0.22, 1, 0.36, 1]
          }} className="group flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-[0_20px_50px_-35px_rgba(13,27,42,0.6)] ring-1 ring-navy-900/5 transition-shadow duration-500 hover:shadow-[0_40px_70px_-40px_rgba(13,27,42,0.65)]" data-id="element-302" data-mp="2xcufpdwdjy2e">
                <div className="relative aspect-[4/3] overflow-hidden" data-id="element-303" data-mp="3g20zz5ctgxqb">
                  <img src={service.image} alt={service.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.07]" data-id="element-304" data-mp="3l02klupw553w" />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 via-transparent to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-90" data-id="element-305" data-mp="1pjko3c3m4b4j" />
                </div>
                <div className="flex flex-1 flex-col p-7" data-id="element-306" data-mp="1gpy0i99k6e6f">
                  <h3 className="font-display text-2xl tracking-[-0.01em] text-navy-900" data-id="element-307" data-mp="1bthaf9istpqp">
                    {service.title}
                  </h3>
                  <p className="mt-3 flex-1 text-[15px] leading-relaxed text-ink-700/70" data-id="element-308" data-mp="16ri71zn26str">
                    {service.description}
                  </p>
                  <span className="mt-6 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-brass-dark" data-id="element-309" data-mp="xty32ixtaifg">
                    Learn More
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" aria-hidden="true" data-id="element-310" data-mp="2s6nyx67qq1ph" />
                  </span>
                </div>
              </motion.a>
            </Reveal>)}
        </div>
      </div>
    </section>;
}